import React, { createContext, useEffect, useState } from 'react';
import Keycloak, { KeycloakConfig, KeycloakInitOptions } from "keycloak-js";

/**
 * KeycloakConfig configures the connection to the Keycloak server.
 */
const keycloakConfig = {
    realm: "Cashapp",
    clientId: "yara-portal",
    url: "https://app-keycloak-test.azurewebsites.net/auth/",
};

/**
 * KeycloakInitOptions configures the Keycloak client.
 */
const keycloakInitOptions = {
    // Configure that Keycloak will check if a user is already authenticated (when opening the app or reloading the page). If not authenticated the user will be send to the login form. If already authenticated the webapp will open.
    onLoad: "login-required",
};

// Create the Keycloak client instance
const keycloak = Keycloak(keycloakConfig);

/**
 * AuthContextValues defines the structure for the default values of the {@link AuthContext}.
 */
//interface AuthContextValues {
//    /**
//     * Whether or not a user is currently authenticated
//     */
//    isAuthenticated: boolean;
//    /**
//     * The name of the authenticated user
//     */
//    username: string;
//    /**
//     * Function to initiate the logout
//     */
//    logout: () => void;
//    /**
//     * Check if the user has the given role
//     */
//    hasRole: (role: string) => boolean;
//}

/**
 * Default values for the {@link AuthContext}
 */
const defaultAuthContextValues = {
    isAuthenticated: false,
    username: "",
    logout: () => { },
    hasRole: (role) => false,
    setToken: () => { },
    userInfo: {}
};

/**
 * Create the AuthContext using the default values.
 */
export const AuthContext = createContext(
    defaultAuthContextValues
);



/**
 * The props that must be passed to create the {@link AuthContextProvider}.
 */
//interface AuthContextProviderProps {
//    /**
//     * The elements wrapped by the auth context.
//     */
//    children: JSX.Element;
//}

/**
 * AuthContextProvider is responsible for managing the authentication state of the current user.
 *
 * @param props
 */
const AuthContextProvider = (props) => {
    //console.log("rendering AuthContextProvider");    

    // Create the local state in which we will keep track if a user is authenticated
    const [isAuthenticated, setAuthenticated] = useState(false);
    // Local state that will contain the users name once it is loaded
    const [username, setUsername] = useState("");

    const [userInfo, setUserInfo] = useState({});

    // Effect used to initialize the Keycloak client. It has no dependencies so it is only rendered when the app is (re-)loaded.
    useEffect(() => {
        /**
         * Initialize the Keycloak instance
         */
        async function initializeKeycloak() {
            //console.log("initialize Keycloak");
            try {
                const isAuthenticatedResponse = await keycloak.init(
                    keycloakInitOptions
                );

                if (localStorage.getItem("tknkyclk") === "1") {
                    //console.log("El token es 1");
                    localStorage.setItem("tknkyclk", "");
                    localStorage.setItem("tknkyclkimp", "");
                    logout();
                    //console.log("Se va a hacer logout");
                } else {
                    // If the authentication was not successfull the user is send back to the Keycloak login form
                    if (!isAuthenticatedResponse) {
                        //console.log("user is not yet authenticated. forwarding user to login.");
                        localStorage.setItem("tknkyclk", "");
                        localStorage.setItem("tknkyclkimp", "");
                        keycloak.login();

                    } else {
                        setToken();
                        //console.log(isAuthenticatedResponse, "la primer vez");
                    }


                    // If we get here the user is authenticated and we can update the state accordingly
                    //console.log("user already authenticated");

                    setAuthenticated(isAuthenticatedResponse);

                }


            } catch {
                //console.log("error initializing Keycloak");
                localStorage.setItem("tknkyclk", "");
                localStorage.setItem("tknkyclkimp", "");
                setAuthenticated(false);
            }
        }

        initializeKeycloak();
    }, []);

    // This effect loads the users profile in order to extract the username
    useEffect(() => {
        /**
         * Load the profile for of the user from Keycloak
         */
        async function loadProfile() {
            try {
                const profile = await keycloak.loadUserProfile();

                if (profile.firstName) {
                    setUsername(profile.firstName);
                } else if (profile.username) {
                    setUsername(profile.username);
                }
            } catch {
                console.log("error trying to load the users profile");
            }
        }

        // Only load the profile if a user is authenticated
        if (isAuthenticated) {
            loadProfile();
        }
    }, [isAuthenticated]);

    /**
     * Initiate the logout
     */
    const logout = () => {
        keycloak.logout();
    };

    /**
     * Check if the user has the given role
     * @param role to be checked
     * @returns whether or not if the user has the role
     */
    const hasRole = (role) => {
        return keycloak.hasRealmRole(role);
    };

    const getToken = () => keycloak.token;


    const setToken = () => {

        //if (!isAuthenticated)
        //    keycloak.login();
        //else {
        //console.log("haciendo el set del token");
        localStorage.setItem("tknkyclk", keycloak.token);

        //}
    };

    // Setup the context provider
    return (<AuthContext.Provider
        value={{
            isAuthenticated,
            username,
            logout,
            hasRole,
            getToken,
            setToken
        }}
    >
        {props.children}
    </AuthContext.Provider>
    );
};

export default AuthContextProvider;